import styles from './FriendRequests.module.scss';
import { pendingRequests } from '../../data';
import { useReducer } from 'react';
import reducer from './friend-requests-reducer';
import FoldableCards from '../foldable-cards/FoldableCards';

const initialState = {
  pendingRequests: pendingRequests,
};
const FriendRequests = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <main className={styles.friendRequestsCard}>
      <FoldableCards
        payload={state.pendingRequests}
        type={`Pending Requests`}
      />
    </main>
  );
};

export default FriendRequests;
